// Validation utilities

export const isValidEmail = (email: string | null | undefined): boolean => {
  if (!email || typeof email !== 'string') {
    return false;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidName = (name: string): boolean => {
  return name.trim().length >= 2;
};

export const validateParticipant = (name: string, email: string): string | null => {
  if (!isValidName(name)) {
    return 'Name must be at least 2 characters long';
  }
  if (!isValidEmail(email)) {
    return 'Please enter a valid email address';
  }
  return null;
};

export const validateGroupName = (name: string): string | null => {
  if (name.trim().length < 3) {
    return 'Group name must be at least 3 characters long';
  }
  if (name.trim().length > 50) {
    return 'Group name must be less than 50 characters';
  }
  return null;
};

export const validateMinParticipants = (count: number): string | null => {
  if (count < 3) {
    return 'You need at least 3 participants for Secret Santa';
  }
  return null;
};

